import axios from "axios";
const jsonConfig = require("../../Config.json");



const GetRecentActivitiesGraph = async (payload) => {
  try {
    const getAllResponse = await axios.post(
      jsonConfig.apiUrl + "recentactivitiesgraph/" + payload.id, { role: payload.role,recruitmentpartnerId:payload.recruitmentpartnerId },
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );
    return Promise.resolve(getAllResponse);
  } catch (error) {
    return Promise.reject(error);
  }
};
export default GetRecentActivitiesGraph;